import { Controller } from "stimulus"
import consumer from '../channels/consumer'

export default class extends Controller {
  static targets = [ "advancedFrequency", 
                     "dimensionRow", 
                     "dropzoneDrop", 
                     "dropzoneProcessing", 
                     "dropzoneError", 
                     "dropzoneErrorMessage",
                     "uploadSection" ]
 
  connect() {
  }

  disconnect() {
    if (this.channel) {
      this.channel.unsubscribe()
      this.channel = null
    }
  }

  fileUploaded(event) {
    // Hide the drop target and show the processing box
    this.dropzoneDropTarget.classList.add('hidden')
    this.dropzoneProcessingTarget.classList.remove('hidden')

    let datasetUploadController = this;
    // We want to listen to updates on the channel so we know when the
    // file is done parsing
    this.channel = consumer.subscriptions.create("DatasetUploadChannel", {
      connected() {
        datasetUploadController.sendUploadForParsing();
      },

      disconnected() {
      },

      received(upload) {
        if (upload.id == datasetUploadController.upload) {
          if (upload.error) {
            datasetUploadController.displayDropError(upload.error)
          }
          else {
            datasetUploadController.loadUploadPreview()
          }
        }
      }
    })
  }

  fullFrequencies(event) {
    event.preventDefault()
    event.currentTarget.classList.add('hidden')

    this.advancedFrequencyTargets.forEach((target) => {
      target.hidden = false
    })
  }

  toggleDimension(event) {
    event.currentTarget.closest('tr').querySelectorAll('input[type=text]').forEach(function(text) {
      if (event.currentTarget.checked) {
        text.disabled = false
        text.classList.remove("opacity-50", "cursor-not-allowed")
      }
      else {
        text.disabled = true
        text.classList.add("opacity-50", "cursor-not-allowed")
      }
    })
  }

  toggleTimeseriesRow(event) {
    let timeseriesIndex = event.currentTarget.options[event.currentTarget.selectedIndex].value

    this.dimensionRowTargets.forEach((dimension) => {
      dimension.classList.toggle("hidden", dimension.dataset.headerIndex == timeseriesIndex)
    })
  }

  sendUploadForParsing() {
    // Grab the direct_upload source uid and pass it over to our
    // parseUrl on the server

    fetch(encodeURI(this.data.get('parseUrl')), {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'text/javascript',
        'X-CSRF-Token': document.querySelector("[name='csrf-token']").content,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({source: document.querySelector("input[type='hidden'][name='dataset_upload[source]']").value})
    })
    .then(response => response.json())
    .then(data => {
      if (data.error) {
        this.displayDropError(data.error)
      }
      else {
        this.upload = data.upload
      }
    });

  }

  loadUploadPreview() {
    let url = this.data.get('previewUrl')
    fetch(encodeURI(`${url}?upload=${this.upload}`))
    .then(response => response.text())
    .then(html => {
      this.uploadSectionTarget.innerHTML = html
    })
  }

  displayDropError(message) {
    this.dropzoneProcessingTarget.classList.add('hidden')
    this.dropzoneErrorMessageTarget.innerText = message
    this.dropzoneErrorTarget.classList.remove('hidden')
  }
}
